import { render } from "./OAuthComplete.vue?vue&type=template&id=37f446e4&scoped=true"
import script from "./OAuthComplete.vue?vue&type=script&lang=js"
export * from "./OAuthComplete.vue?vue&type=script&lang=js"

import "./OAuthComplete.vue?vue&type=style&index=0&id=37f446e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f446e4"]])

export default __exports__
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerGears,QSeparator,QBtn});
